<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Kds Station {{ (kds_station.station_name) ? (" - " + kds_station.station_name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Kds Station - {{kds_station.station_name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Kds Station - {{kds_station.station_name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="kds_station.code" :disabled="viewMode" slot-scope="" input-classes="form-control" />
                <base-input alternative="" label="Station Name" placeholder="" v-model="kds_station.station_name" :disabled="viewMode" slot-scope="" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="remark" :disabled="viewMode"/>
                </base-input>
            </div>


            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>

                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Kitchen Station?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

            component_x = this
            if (component_x.profileId > 0) {
                var kds_station_data = await HTTPRequest.getRequest(component_x.endPoint + 'kds_stations/' + component_x.profileId, null)
                if (kds_station_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (kds_station_data["error"] == undefined) {
                        component_x.kds_station = kds_station_data
                        component_x.remark = kds_station_data["remark"]
                    } else {
                        this.errors = kds_station_data["error"].split(",")
                    }
                }
            }
        },
        data: function () {
            return {
                errors: [],
                remark: '',
                customFormMode: 1,
                customForm: {},
                profileData: {},
                kds_station: {
                    code: '',
                    station_name: ''
                },
                formErrors: [],
                viewMode: this.$attrs.viewMode,
            }
        },
        methods: {
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Name', this.kds_station.station_name));
                this.errors.push(ValidateField.charMinAndMax('Code', this.kds_station.code, 0, 30));
                this.errors.push(ValidateField.charMinAndMax('Name', this.kds_station.station_name, 0, 50));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    if(this.kds_station.code)
                        this.kds_station.code = this.kds_station.code.trim()
                    this.kds_station.code = this.kds_station.code.trim()
                    this.kds_station.remark = this.remark.trim()
                    this.kds_station.status = 'A'
                    var kdsStationPayload = { kds_station: this.kds_station }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'kds_stations', null, kdsStationPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    if(this.kds_station.code)
                        this.kds_station.code = this.kds_station.code.trim()
                    this.kds_station.station_name = this.kds_station.station_name.trim()
                    this.kds_station.remark = this.remark.trim()
                    let status = (this.kds_station.status == null) ?  "A" : this.kds_station.status
                    this.kds_station.status = status
                    var kdsStationPayload = { kds_station: this.kds_station }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'kds_stations/' + this.profileId, null, kdsStationPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>